import { render } from "./AutoSearch.vue?vue&type=template&id=4f6bfb5d&scoped=true"
import script from "./AutoSearch.vue?vue&type=script&lang=js"
export * from "./AutoSearch.vue?vue&type=script&lang=js"

import "./AutoSearch.vue?vue&type=style&index=0&id=4f6bfb5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6bfb5d"]])

export default __exports__